import { Badge } from '@smartsash/ui';
import { useTranslation } from 'react-i18next';

import { statusColor, statusLabelKey } from './serviceRequestLabels';

/** A request's status as a coloured badge; a status the client does not know renders neutral. */
export function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const key = statusLabelKey(status);
  return (
    <Badge color={statusColor(status)} size="sm" dot>
      {key === undefined ? status : t(key)}
    </Badge>
  );
}

export default StatusBadge;
